import { useContext } from 'react';
import DoctorContext from 'src/context/DoctorProvider';

export const useDoctor = () => {
  const doctor = useContext(DoctorContext);
  return doctor;
};
